export const ru = {
    error_required: 'Заполните это поле',
    error_must_be_a_number: 'Допустимо только число',
};
